import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { layoutSelector } from 'core/store/layout/selectors';
import { useAppSelector } from 'core/store/store.utils';
import { getNavigate, setMaintenanceError, setNavigate } from 'shared/utils/maintenance.utils';

export const MaintenanceContainer = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const layout = useAppSelector(layoutSelector);
  const { maintenanceError } = layout;

  useEffect(() => {
    if (!getNavigate()) setNavigate(navigate);
    setMaintenanceError(maintenanceError);
  }, [maintenanceError, navigate]);

  return children;
};
